var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"flag-icon",attrs:{"src":_vm.flagUrl,"title":_vm.countryName || _vm.countryCode,"alt":_vm.countryName,"width":_vm.width,"height":_vm.height},on:{"error":_vm.onImageError}})
}
var staticRenderFns = []

export { render, staticRenderFns }